<template>
  <v-select
    :items='colors'
    v-model='val'
    :label='label'
    :rules='required ? [rules.required] : []'
    @select="$emit('input', returnValue)"
  >
    <template v-slot:item='{ item }'>
      <v-badge inline :color='item'></v-badge>
    </template>
    <template v-slot:selection='{ item }'>
      <v-badge inline :color='item'></v-badge>
    </template>
  </v-select>

</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'wc-color-picker',
  mixins: [formRules],
  props: {
    value: {
      required: true
    },
    label: {
      required: false,
      default: 'Colors'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    colors: {
      required: false,
      default: function () {
        return [
          'indigo',
          'deep-purple',
          'purple',
          'blue',
          'light-blue',
          'cyan',
          'info',
          'primary',
          'teal',
          'success',
          'light-green',
          'lime',
          'yellow',
          'amber',
          'warning',
          'pink',
          'deep-orange',
          'error',
          'brown',
          'blue-grey',
          'grey',
          'secondary'
        ]
      }
    }
  },
  data: () => ({
    val: null
  }),
  mounted () {
    this.val = this.value
    this.updateColor()
  },
  watch: {
    val () {
      this.updateColor()
    },
    value: function () {
      this.val = this.value
      this.updateColor()
    }
  },
  methods: {
    updateColor () {
      this.$emit('input', this.val)
    }
  }
}
</script>
